import React from "react";
import styled from "styled-components";

const CustomCheckbox = ({
  label,
  value,
  checked,
  onChange,
  name,
  className,
}) => {
    
  return (
    <CheckboxWrapper checked={checked} className={`${className ? className : ""}`}>
      <input
        className="radio-input"
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <span className="radio-text mx-2 text-nowrap" checked={checked}>
        {label}
      </span>
    </CheckboxWrapper>
  );
};

export default CustomCheckbox;

const CheckboxWrapper = styled.label`
  display: flex;
  align-items: end;
  width: 100%;
  padding: 11px 15px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: var(--white);
  border: 1px solid
    ${(props) =>
      props.checked ? "var(--themeColorSecondary)" : "var(--border)"};

  .radio-input {
    appearance: none;
    /* min-width: 25px;
    max-width: 25px;
    height: 25px;
    border: 2px solid var(--border);
    background-color: var(--bg);
    border-radius: 10%;
    position: relative;

    &:checked {
      border: 7px solid var(--themeColorSecondary);
      background-color: var(--themeColorSecondary);
    }
    &:checked::after {
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 10%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: var(--white);
    } */
  }
  .radio-text {
    font-family: ${(props) =>
      props.checked ? "var(--semiBold)" : "var(--regular)"};
    color: ${(props) =>
      props.checked ? "var(--themeColorSecondary)" : "var(--lightGrey)"};
    body.rtl & {
      font-family: ${(props) =>
        props.checked ? "var(--arSemiBold)" : "var(--arRegular)"};
    }
  }
`;
